import { gql } from "@apollo/client";

const ME_OWNER = gql`
  query MeOwner {
    meOwner {
      id
      name
      displayName
      email
      password
      logo
      color
      textColor
      phone
      siret
      addresses
      cards { id }
      BCNB
      BCED
      BCCG
      commerceType
      offer
      offerMsgs
      isActive
    }
  }
`

const OWNER = gql`
  query Owner ($id: ID!){
    owner(id: $id) {
      id
      emailVerified
    }
  }
`

const MYQRCODE = gql`
  query Myqrcode {
    myqrcode
  }
`

export { ME_OWNER, OWNER, MYQRCODE }